"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var GlobalStateContext_1 = require("../../utils/GlobalStateContext");
require("./_ContentTabs.scss");
var ContentTabs = function () {
    // global state context things
    var context = (0, react_1.useContext)(GlobalStateContext_1.GlobalStateContext);
    var state = context.state, setState = context.setState;
    var setActiveTab = function (newActiveTab) { return setState(function (prevState) { return (__assign(__assign({}, prevState), { currentTabIndex: newActiveTab })); }); };
    var _a = (0, react_1.useState)(''), tab1Text = _a[0], setTab1Text = _a[1];
    var _b = (0, react_1.useState)(''), tab2Text = _b[0], setTab2Text = _b[1];
    (0, react_1.useEffect)(function () {
        setTab1Text(window.bes.spareparts.tab1text);
        setTab2Text(window.bes.spareparts.tab2text);
    }, []);
    // local vars
    var tabNames = [
        tab1Text,
        tab2Text
    ];
    // tabbed navigation tab content toggle things
    var handleTabClick = function (index) {
        setActiveTab(index);
    };
    return (react_1.default.createElement("ul", { className: "nav spr-content-tabs mb-3" }, tabNames.map(function (tabName, index) { return (react_1.default.createElement("li", { className: "nav-item spr-content-tabs__item", key: index },
        react_1.default.createElement("div", { className: "spr-content-tabs__link-wrapper" },
            react_1.default.createElement("div", { className: "spr-content-tabs__link nav-link ".concat(index === state.currentTabIndex ? "active" : ""), "aria-current": index === state.currentTabIndex ? "page" : undefined, onClick: function () { return handleTabClick(index); } }, tabName),
            react_1.default.createElement("div", { className: "spr-content-tabs__underline ".concat(index === state.currentTabIndex ? "active" : "") })))); })));
};
ContentTabs.displayName = "Content Tabs";
exports.default = ContentTabs;
